import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';
import { camelizeKeys } from '../utils/camelizeKeys';
import Dashboard from '../planner/dashboard/Dashboard';
import Prospects from '../pages/planner/prospects/Prospects';
import MyClients from '../pages/planner/myClients/MyClients';
import TeamClients from '../pages/planner/teamClients/TeamClients';
import Login from '../pages/auth/Login';
import ClientProfile from '../pages/planner/client/profile/ClientProfile';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import PlannerClientDashboard from '../pages/planner/client/dashboard/ClientDashboard';

import ClientLogin from '../pages/auth/client/Login';
import ClientForgotPassword from '../pages/auth/client/ForgotPassword';
import ClientResetPassword from '../pages/auth/client/ResetPassword';
import ClientDashboard from '../pages/client/Dashboard';
import ClientMyPlan from '../pages/client/MyPlan';
import ClientInvestmentPolicies from '../pages/client/InvestmentPolicy';
import ClientDocuments from '../pages/client/Documents';
import ClientAccount from '../pages/client/Account';
import ClientMovements from '../pages/client/Movements';

import AnalystClients from '../pages/analyst/Clients';
import AnalystAssets from '../pages/analyst/Assets';
import AnalystWalletConfigs from '../pages/analyst/WalletConfigs';
import AnalystClientDashboard from '../pages/analyst/client/dashboard/ClientDashboard';
import GlobalSettings from '../pages/analyst/GlobalSettings';
import AccessProfiles from '../pages/master/AccessProfiles';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('app-root');
  if (!container) return;

  const data = container.dataset;
  const page = data.page;

  const rawProps = data.props ? JSON.parse(data.props) : {};
  const props = camelizeKeys(rawProps);

  const root = createRoot(container);

  const renderPage = () => {
    switch (page) {
      case 'login':
        return <Login {...props} />;
      case 'forgot_password':
        return <ForgotPassword {...props} />;
      case 'reset_password':
        return <ResetPassword {...props} />;
      case 'dashboard':
        return <Dashboard {...props} />;
      case 'prospects':
        return <Prospects {...props} />;
      case 'my_clients':
        return <MyClients {...props} />;
      case 'team_clients':
        return <TeamClients {...props} />;
      case 'client/id/profile':
        return <ClientProfile {...props} />;
      case 'client/id/dashboard':
        return <PlannerClientDashboard {...props} />;
      // Clients
      case 'client_login':
        return <ClientLogin {...props} />;
      case 'client_forgot_password':
        return <ClientForgotPassword {...props} />;
      case 'client_reset_password':
        return <ClientResetPassword {...props} />;
      case 'client_dashboard':
        return <ClientDashboard {...props} />;
      case 'client_my_plan':
        return <ClientMyPlan {...props} />;
      case 'client_investment_policies':
        return <ClientInvestmentPolicies {...props} />;
      case 'client_documents':
        return <ClientDocuments {...props} />;
      case 'client_account':
        return <ClientAccount {...props} />;
      case 'client_movements':
        return <ClientMovements {...props} />;
      // Analyst
      case 'analyst_clients':
        return <AnalystClients {...props} />;
      case 'analyst_assets':
        return <AnalystAssets {...props} />;
      case 'analyst_wallet_configs':
        return <AnalystWalletConfigs {...props} />;
      case 'analyst_client_dashboard':
        return <AnalystClientDashboard {...props} />;
      case 'analyst_global_settings':
        return <GlobalSettings {...props} />;
      // Master
      case 'master_access_profiles':
        return <AccessProfiles {...props} />;
      default:
        return <div>Página não encontrada</div>;
    }
  };

  root.render(<App {...props}>{renderPage()}</App>);
});
